import React, { useEffect, useState, useCallback } from 'react';
import api from '../services/api';
import Modal from './Modal';
import Spinner from './Spinner';
import { toast } from './Toast';
import { exportCSV, printTable, printFoaieConsolidata } from './ExportButton';

const EMPTY_FOAIE = {
  nrInmatriculare:'', username:'', dataFoii:'', oraPlecare:'', oraSosire:'',
  kmPlecare:'', kmSosire:'', traseu:'', scopDeplasarii:'', consumNormat:'', consumEfectiv:'', observatii:'',
  distantaGps:null, cursaGpsId:null
};

const EMPTY_CMR = {
  nrInmatriculare:'', username:'',
  expeditorNume:'', expeditorAdresa:'', expeditorTara:'',
  destinatarNume:'', destinatarAdresa:'', destinatarTara:'',
  locLivrare:'', tara3:'', locIncarcare:'', dataIncarcare:'',
  documenteAnexate:'',
  marcaje:'', nrColete:'', modAmbalare:'', naturaMarfii:'', nrStatistic:'', greutateBruta:'', volum:'',
  instructiuniExpeditor:'', ramburs:'',
  transportatorNume:'', transportatorAdresa:'', transportatorTara:'',
  transportatoriSuccesivi:'', rezerveTransportator:'', conventiiSpeciale:'',
  pretTransport:'', reduceri:'', sold:'', taxeSuplimentare:'', alteCheltuieli:'', totalDePlata:'',
  locIntocmire:'', dataIntocmire:'',
  semnatExpeditor:false, semnatTransportator:false, semnatDestinatar:false,
};

function fmt(val) {
  return parseFloat(val||0).toLocaleString('ro-RO', {minimumFractionDigits:2, maximumFractionDigits:2});
}
function FilterInput({ value, onChange }) {
  return <input value={value} onChange={e=>onChange(e.target.value)} placeholder="Filtrează..."
    style={{width:'100%',padding:'3px 6px',fontSize:11,border:'1px solid #ccc',borderRadius:3}}/>;
}

// Print pentru o foaie de parcurs - format clasic, cu tot ce cere in practica un control
// fiscal/rutier (nu exista formular tipizat impus prin lege, dar structura de mai jos
// acopera toate datele esentiale cerute).
function printFoaieParcurs(r) {
  const kmParcursi = (r.kmSosire!=null && r.kmPlecare!=null) ? (r.kmSosire - r.kmPlecare) : '';
  const html = `
    <html><head><title>Foaie de parcurs</title>
    <style>
      @page { size: A4; margin: 16mm; }
      body{font-family:Arial,sans-serif;font-size:13px;color:#111}
      h2{text-align:center;margin-bottom:2px}
      .sub{text-align:center;color:#555;margin-bottom:18px;font-size:12px}
      table{width:100%;border-collapse:collapse;margin-bottom:16px}
      td,th{border:1px solid #999;padding:6px 8px;text-align:left}
      .lbl{background:#f0f0f0;font-weight:bold;width:220px}
      .semnaturi{display:flex;justify-content:space-between;margin-top:50px}
      .semnaturi div{text-align:center;width:200px;border-top:1px solid #333;padding-top:6px}
      @media print{button{display:none}}
    </style></head><body>
    <h2>FOAIE DE PARCURS</h2>
    <div class="sub">Nr. ${r.nrCrt} — ${r.dataFoii}</div>
    <table>
      <tr><td class="lbl">Vehicul (nr. înmatriculare)</td><td>${r.nrInmatriculare||''}</td></tr>
      <tr><td class="lbl">Conducător auto</td><td>${r.username||''}</td></tr>
      <tr><td class="lbl">Data</td><td>${r.dataFoii||''}</td></tr>
      <tr><td class="lbl">Ora plecare / Ora sosire</td><td>${r.oraPlecare||''} — ${r.oraSosire||''}</td></tr>
      <tr><td class="lbl">Traseu</td><td>${r.traseu||''}</td></tr>
      <tr><td class="lbl">Scopul deplasării</td><td>${r.scopDeplasarii||''}</td></tr>
      <tr><td class="lbl">Km la plecare</td><td>${r.kmPlecare??''}</td></tr>
      <tr><td class="lbl">Km la sosire</td><td>${r.kmSosire??''}</td></tr>
      <tr><td class="lbl">Km parcurși</td><td><b>${kmParcursi}</b></td></tr>
      <tr><td class="lbl">Consum normat (l/100km)</td><td>${r.consumNormat||''}</td></tr>
      <tr><td class="lbl">Consum efectiv (l/100km)</td><td>${r.consumEfectiv||''}</td></tr>
      <tr><td class="lbl">Observații</td><td>${r.observatii||''}</td></tr>
    </table>
    <div class="semnaturi">
      <div>Conducător auto</div>
      <div>Verificat / Dispecerat</div>
    </div>
    <script>window.onload=()=>window.print()</script>
    </body></html>`;
  const w = window.open('', '_blank');
  w.document.write(html); w.document.close();
}

// Print CMR - toate cele 24 de casete standard, plus avertismentul legal (vezi tab-ul CMR
// din interfata pentru explicatia completa).
function printCmr(r) {
  const html = `
    <html><head><title>CMR - Contract de Transport</title>
    <style>
      @page { size: A4; margin: 12mm; }
      body{font-family:Arial,sans-serif;font-size:11px;color:#111}
      h2{text-align:center;margin-bottom:4px}
      .warn{background:#fde8e8;color:#c0392b;border:1px solid #e0a0a0;border-radius:6px;padding:8px 12px;margin-bottom:14px;font-size:10.5px}
      table{width:100%;border-collapse:collapse;margin-bottom:10px}
      td,th{border:1px solid #999;padding:5px 7px;vertical-align:top}
      .n{background:#f0f0f0;font-weight:bold;width:26px;text-align:center}
      .lbl{color:#555;font-size:9.5px;display:block;margin-bottom:2px}
      @media print{button{display:none}}
    </style></head><body>
    <h2>CMR — CONTRACT DE TRANSPORT</h2>
    <div class="warn">⚠️ Document de evidență internă / pre-completare. NU înlocuiește scrisoarea CMR
    originală din carnetul tipizat, numerotat și autocopiativ, singura cu valoare juridică deplină
    conform Convenției CMR (Geneva, 1956).</div>
    <table>
      <tr>
        <td class="n">1</td><td style="width:46%"><span class="lbl">Expeditor</span>${r.expeditorNume||''}<br/>${r.expeditorAdresa||''}, ${r.expeditorTara||''}</td>
        <td class="n">2</td><td><span class="lbl">Destinatar</span>${r.destinatarNume||''}<br/>${r.destinatarAdresa||''}, ${r.destinatarTara||''}</td>
      </tr>
      <tr>
        <td class="n">3</td><td><span class="lbl">Locul eliberării mărfii</span>${r.locLivrare||''}, ${r.tara3||''}</td>
        <td class="n">4</td><td><span class="lbl">Locul și data încărcării</span>${r.locIncarcare||''} — ${r.dataIncarcare||''}</td>
      </tr>
      <tr><td class="n">5</td><td colspan="3"><span class="lbl">Documente anexate</span>${r.documenteAnexate||''}</td></tr>
      <tr>
        <td class="n">6-12</td>
        <td colspan="3">
          <span class="lbl">Descrierea mărfii</span>
          Mărci/nr.: ${r.marcaje||''} &nbsp;|&nbsp; Nr. colete: ${r.nrColete||''} &nbsp;|&nbsp; Ambalaj: ${r.modAmbalare||''}<br/>
          Natura mărfii: ${r.naturaMarfii||''} &nbsp;|&nbsp; Nr. statistic: ${r.nrStatistic||''}<br/>
          Greutate brută: ${r.greutateBruta||''} kg &nbsp;|&nbsp; Volum: ${r.volum||''} m³
        </td>
      </tr>
      <tr><td class="n">13</td><td colspan="3"><span class="lbl">Instrucțiuni ale expeditorului</span>${r.instructiuniExpeditor||''}</td></tr>
      <tr><td class="n">15</td><td colspan="3"><span class="lbl">Ramburs</span>${r.ramburs||''}</td></tr>
      <tr>
        <td class="n">16</td><td colspan="3"><span class="lbl">Transportator</span>${r.transportatorNume||''}<br/>${r.transportatorAdresa||''}, ${r.transportatorTara||''}
          ${r.nrInmatriculare?` — Vehicul: <b>${r.nrInmatriculare}</b>`:''}${r.username?` — Șofer: <b>${r.username}</b>`:''}</td>
      </tr>
      <tr><td class="n">17</td><td colspan="3"><span class="lbl">Transportatori succesivi</span>${r.transportatoriSuccesivi||''}</td></tr>
      <tr><td class="n">18</td><td colspan="3"><span class="lbl">Rezervele transportatorului</span>${r.rezerveTransportator||''}</td></tr>
      <tr><td class="n">19</td><td colspan="3"><span class="lbl">Convenții speciale</span>${r.conventiiSpeciale||''}</td></tr>
      <tr>
        <td class="n">20</td>
        <td colspan="3">
          <span class="lbl">De plată</span>
          Preț transport: ${fmt(r.pretTransport)} &nbsp;|&nbsp; Reduceri: ${fmt(r.reduceri)} &nbsp;|&nbsp; Sold: ${fmt(r.sold)}<br/>
          Taxe suplimentare: ${fmt(r.taxeSuplimentare)} &nbsp;|&nbsp; Alte cheltuieli: ${fmt(r.alteCheltuieli)}
          &nbsp;|&nbsp; <b>Total: ${fmt(r.totalDePlata)}</b>
        </td>
      </tr>
      <tr><td class="n">21</td><td colspan="3"><span class="lbl">Întocmit la</span>${r.locIntocmire||''} — ${r.dataIntocmire||''}</td></tr>
      <tr>
        <td class="n">22</td><td>${r.semnatExpeditor?'✅ Semnat':'—'}<br/><span class="lbl">Expeditor</span></td>
        <td class="n">23</td><td>${r.semnatTransportator?'✅ Semnat':'—'}<br/><span class="lbl">Transportator</span></td>
      </tr>
      <tr><td class="n">24</td><td colspan="3">${r.semnatDestinatar?'✅ Semnat':'—'} <span class="lbl" style="display:inline">Destinatar (marfă primită)</span></td></tr>
    </table>
    <script>window.onload=()=>window.print()</script>
    </body></html>`;
  const w = window.open('', '_blank');
  w.document.write(html); w.document.close();
}

export default function DocumenteTransportTab({ openFoaieId, onOpenedFoaie }) {
  const isDriver = (localStorage.getItem('rol') || '') === 'conducator_auto';
  // v68: "poate prelua din cursa GPS" nu mai e legat strict de rolul conducator_auto -
  // orice cont cu un vehicul asignat (inclusiv un admin caruia i s-a asignat optional
  // o masina) are propriile curse GPS de preluat. isDriver ramane neschimbat pentru
  // restrictiile de editare/stergere de mai jos - acelea tin strict de rol, la fel ca
  // pe backend (un admin-cu-masina pastreaza dreptul de a modifica/sterge orice).
  const poateConduce = !!(localStorage.getItem('vehiculAsignat') || '');
  const [tab, setTab] = useState('foi-parcurs');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [nruri, setNruri] = useState([]);
  const [soferi, setSoferi] = useState([]);
  const [filters, setFilters] = useState({});
  // v68: interval de dată pentru listarea foilor de parcurs (dataFoii e 'YYYY-MM-DD',
  // comparație directă pe șiruri funcționează corect pentru interval).
  const [dataDe, setDataDe] = useState('');
  const [dataPana, setDataPana] = useState('');
  // Foaie de parcurs consolidata (o zi, un vehicul - vezi getFoaieConsolidata pe backend).
  const [ziConsolidata, setZiConsolidata] = useState('');
  const [vehiculConsolidat, setVehiculConsolidat] = useState('');
  const [optiuniVehiculeConsolidat, setOptiuniVehiculeConsolidat] = useState([]);
  const [grupuriConsolidate, setGrupuriConsolidate] = useState(null); // null = neincarcat inca
  const [seIncarcaConsolidat, setSeIncarcaConsolidat] = useState(false);

  useEffect(() => {
    if (tab === 'foi-parcurs') {
      api.get('/api/auto/nruri').then(({ data }) => setOptiuniVehiculeConsolidat(data || [])).catch(() => {});
    }
  }, [tab]);

  const genereazaFoaieConsolidata = async () => {
    if (!ziConsolidata || !vehiculConsolidat) {
      toast('Alege și ziua, și vehiculul.', 'error');
      return;
    }
    setSeIncarcaConsolidat(true);
    try {
      const { data } = await api.get('/api/documente-transport/foaie-consolidata', {
        params: { nrInmatriculare: vehiculConsolidat, data: ziConsolidata },
      });
      setGrupuriConsolidate(data);
      if (data.length === 0) toast('Nicio cursă în acea zi, pentru acel vehicul.', 'error');
    } catch (e) {
      toast(e.response?.data?.error || 'Nu am putut genera foaia consolidată.', 'error');
    } finally {
      setSeIncarcaConsolidat(false);
    }
  };
  const [sort, setSort] = useState({ col:'dataFoii', dir:'desc' });
  const [selectedRow, setSelectedRow] = useState(null);
  const [modal, setModal] = useState(null);
  const [formFoaie, setFormFoaie] = useState(EMPTY_FOAIE);
  const [formCmr, setFormCmr] = useState(EMPTY_CMR);
  const [curseGps, setCurseGps] = useState([]);
  const username = localStorage.getItem('username') || '';

  useEffect(() => {
    api.get('/api/auto/nruri').then(r=>setNruri(r.data.map(x=>x.nrInmatriculare)));
    api.get('/api/personal/soferi').then(r=>setSoferi(r.data.map(x=>x.username)));
  }, []);

  // Curse GPS incheiate, neasociate inca unei foi - doar pentru sofer, ca sa
  // poata prelua ora/traseu/distanta direct la adaugarea unei foi noi.
  useEffect(() => {
    if (poateConduce) api.get('/api/cursa-gps/neasociate').then(r=>setCurseGps(r.data)).catch(()=>{});
  }, [poateConduce]);

  const preiaDinCursaGps = (cursaId) => {
    const c = curseGps.find(x => x.id === Number(cursaId));
    if (!c) return;
    setFormFoaie(f => ({
      ...f,
      nrInmatriculare: c.nrInmatriculare,
      username: c.username,
      dataFoii: c.dataStart,
      oraPlecare: c.oraStart || '',
      oraSosire: c.oraStop || '',
      distantaGps: c.distantaGpsKm,
      cursaGpsId: c.id,
      // v74: "de unde - pana unde" din localitatile GPS (daca geocodarea a reusit pentru ambele capete)
      traseu: (c.adresaStart && c.adresaStop) ? `${c.adresaStart} - ${c.adresaStop}` : (f.traseu || ''),
    }));
  };

  const load = useCallback(() => {
    setLoading(true); setSelectedRow(null);
    const url = tab === 'foi-parcurs' ? '/api/documente-transport/foi-parcurs' : '/api/documente-transport/cmr';
    api.get(url).then(r=>setRows(r.data)).finally(()=>setLoading(false));
  }, [tab]);

  useEffect(() => { load(); setFilters({}); }, [load]);

  // v68: dupa "Du-mă la foaie" din avertismentul de la Stop-ul unei curse GPS (vezi
  // CursaGpsTab), Dashboard-ul comuta pe acest tab si trimite id-ul foii de precompletat.
  // Daca eram pe sub-tab-ul CMR, comutam intai pe "foi-parcurs" (asta re-incarca rows prin
  // load() de mai sus) - efectul se re-declanseaza cand rows ajunge sa contina foaia cautata.
  useEffect(() => {
    if (!openFoaieId) return;
    if (tab !== 'foi-parcurs') { setTab('foi-parcurs'); return; }
    const row = rows.find(r => r.nrCrt === openFoaieId);
    if (row) {
      openEditFoaie(row);
      if (onOpenedFoaie) onOpenedFoaie();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openFoaieId, tab, rows]);

  const setFilter = (col,val) => setFilters(prev=>({...prev,[col]:val}));
  const toggleSort = (col) => setSort(prev=>({col,dir:prev.col===col&&prev.dir==='asc'?'desc':'asc'}));
  const sortIcon = (col) => sort.col===col?(sort.dir==='asc'?' ▲':' ▼'):' ⇅';

  const filtered = rows.filter(r=>
    Object.entries(filters).every(([col,val])=>!val||String(r[col]||'').toLowerCase().includes(val.toLowerCase()))
    && (tab!=='foi-parcurs' || !dataDe || !r.dataFoii || r.dataFoii>=dataDe)
    && (tab!=='foi-parcurs' || !dataPana || !r.dataFoii || r.dataFoii<=dataPana)
  );
  // v74: la sortarea dupa Data, foile din aceeasi zi se ordoneaza dupa ora de plecare (apoi dupa
  // nr. crt.), in ACELASI sens ca data; la sortarea dupa Ore, dupa ora apoi dupa data.
  const sorted = [...filtered].sort((a,b)=>{
    const cmp = (x,y) => String(x||'').localeCompare(String(y||''));
    let r = cmp(a[sort.col], b[sort.col]);
    if (r === 0 && tab === 'foi-parcurs') {
      // v76: in aceeasi zi, pe ecran "ultima salvata prima" (nr. crt. in acelasi sens ca data);
      // la sortarea dupa Ore: ora, apoi data.
      const tie = sort.col === 'oraPlecare' ? ['dataFoii'] : [];
      for (const c of tie) { r = cmp(a[c], b[c]); if (r !== 0) break; }
      if (r === 0 && (sort.col === 'dataFoii' || sort.col === 'oraPlecare')) r = (Number(a.nrCrt)||0) - (Number(b.nrCrt)||0);
    }
    return sort.dir==='asc' ? r : -r;
  });

  const SH = ({col,children}) => (
    <th onClick={()=>toggleSort(col)} style={{cursor:'pointer',userSelect:'none',whiteSpace:'nowrap'}}>
      {children}{sortIcon(col)}
    </th>
  );

  // ---------------- Foi de parcurs ----------------

  const openAddFoaie = () => { setFormFoaie({...EMPTY_FOAIE, dataFoii:new Date().toISOString().slice(0,10)}); setModal({tip:'foaie', mode:'add'}); };
  const openEditFoaie = (row) => { setFormFoaie({...row}); setModal({tip:'foaie', mode:'edit', id:row.nrCrt}); };

  // v68: pentru o foaie precompletata automat dintr-o cursa GPS (cursaGpsId setat),
  // aratam clar ce nu s-a completat inca, in loc sa salvam tacut sau sa lasam sa pice o
  // eroare SQL neinteligibila. Nicio schimbare pentru o foaie normala (fara cursaGpsId) -
  // acolo raman doar Vehicul/Șofer/Data obligatorii, ca inainte.
  // v68: kmPlecare/kmSosire se calculeaza acum mereu automat la Stop (vezi
  // CursaGpsController) - nu mai apar in lista de campuri de completat manual.
  const CAMPURI_DE_COMPLETAT_GPS = [
    ['scopDeplasarii', 'Scopul deplasării'], ['consumEfectiv', 'Consum efectiv'],
  ];
  const saveFoaie = async () => {
    if (!formFoaie.nrInmatriculare || !formFoaie.username || !formFoaie.dataFoii) {
      toast('Completează Vehicul, Șofer și Data.', 'error'); return;
    }
    if (formFoaie.cursaGpsId) {
      const lipsa = CAMPURI_DE_COMPLETAT_GPS
        .filter(([cheie]) => formFoaie[cheie] == null || String(formFoaie[cheie]).trim() === '')
        .map(([, eticheta]) => eticheta);
      if (lipsa.length > 0) {
        const continua = window.confirm(
          `Mai lipsesc: ${lipsa.join(', ')}.\n\nSalvezi oricum foaia neterminată, sau renunți ca să le completezi acum?`
        );
        if (!continua) return;
      }
    }
    try {
      const payload = {...formFoaie, operare:username};
      if (modal.mode==='add') await api.post('/api/documente-transport/foi-parcurs', payload);
      else await api.put(`/api/documente-transport/foi-parcurs/${modal.id}`, payload);
      setModal(null); load();
      toast(modal.mode==='add'?'Foaie de parcurs adăugată!':'Foaie de parcurs actualizată!');
    } catch(e) { toast('Eroare: '+(e.response?.data?.error||e.message),'error'); }
  };

  const delFoaie = async (id) => {
    if (!window.confirm('Ștergi foaia de parcurs?')) return;
    try { await api.delete(`/api/documente-transport/foi-parcurs/${id}`); load(); toast('Foaie de parcurs ștearsă!'); }
    catch(e) { toast('Eroare la ștergere','error'); }
  };

  // ---------------- CMR ----------------

  const openAddCmr = () => { setFormCmr({...EMPTY_CMR, dataIntocmire:new Date().toISOString().slice(0,10)}); setModal({tip:'cmr', mode:'add'}); };
  const openEditCmr = (row) => { setFormCmr({...row}); setModal({tip:'cmr', mode:'edit', id:row.nrCrt}); };

  const saveCmr = async () => {
    if (!formCmr.expeditorNume || !formCmr.destinatarNume) {
      toast('Completează cel puțin Expeditor și Destinatar.', 'error'); return;
    }
    try {
      const payload = {...formCmr, operare:username};
      if (modal.mode==='add') await api.post('/api/documente-transport/cmr', payload);
      else await api.put(`/api/documente-transport/cmr/${modal.id}`, payload);
      setModal(null); load();
      toast(modal.mode==='add'?'Document CMR adăugat!':'Document CMR actualizat!');
    } catch(e) { toast('Eroare: '+(e.response?.data?.error||e.message),'error'); }
  };

  const delCmr = async (id) => {
    if (!window.confirm('Ștergi documentul CMR?')) return;
    try { await api.delete(`/api/documente-transport/cmr/${id}`); load(); toast('Document CMR șters!'); }
    catch(e) { toast('Eroare la ștergere','error'); }
  };

  return (
    <div>
      <div className="tabs">
        <button className={`tab-btn ${tab==='foi-parcurs'?'active':''}`} onClick={()=>setTab('foi-parcurs')}>📋 Foi de parcurs</button>
        <button className={`tab-btn ${tab==='cmr'?'active':''}`} onClick={()=>setTab('cmr')}>📦 CMR — Contract de Transport</button>
      </div>

      {tab === 'cmr' && (
        <div style={{background:'#fff8e6',border:'1px solid #f0d78c',borderRadius:6,padding:'10px 14px',margin:'10px 14px 0'}}>
          <b style={{color:'#8a6d00'}}>⚠️ Evidență internă:</b>{' '}
          <span style={{fontSize:12.5,color:'#6b5500'}}>
            Scrisoarea CMR cu valoare juridică deplină e cea din carnetul tipizat, numerotat și autocopiativ.
            Acest tab e un instrument de pre-completare și arhivare internă, nu o înlocuiește.
          </span>
        </div>
      )}

      <div style={{background:'#e8eef5',padding:'8px 14px',borderBottom:'1px solid #d0dcea',display:'flex',gap:16,alignItems:'center',flexWrap:'wrap',marginTop:10}}>
        <span style={{fontSize:12,color:'#555'}}>{filtered.length} înregistrări</span>
        {tab==='foi-parcurs' && (
          <div style={{display:'flex',gap:6,alignItems:'center',fontSize:12,color:'#555'}}>
            <span>De la</span>
            <input type="date" value={dataDe} onChange={e=>setDataDe(e.target.value)} style={{padding:4}}/>
            <span>până la</span>
            <input type="date" value={dataPana} onChange={e=>setDataPana(e.target.value)} style={{padding:4}}/>
            {(dataDe||dataPana) && (
              <button className="btn btn-sm" onClick={()=>{setDataDe('');setDataPana('');}}>✕</button>
            )}
          </div>
        )}
        {tab==='foi-parcurs' && (
          <div style={{display:'flex',gap:6,alignItems:'center',fontSize:12,color:'#555',borderLeft:'1px solid #c5d2e0',paddingLeft:16}}>
            <span>Foaie consolidată — zi</span>
            <input type="date" value={ziConsolidata} onChange={e=>setZiConsolidata(e.target.value)} style={{padding:4}}/>
            <select value={vehiculConsolidat} onChange={e=>setVehiculConsolidat(e.target.value)} style={{padding:4}}>
              <option value="">Vehicul...</option>
              {optiuniVehiculeConsolidat.map(v => <option key={v.nrInmatriculare} value={v.nrInmatriculare}>{v.nrInmatriculare}</option>)}
            </select>
            <button className="btn btn-sm btn-success" disabled={seIncarcaConsolidat} onClick={genereazaFoaieConsolidata}>
              {seIncarcaConsolidat ? 'Se generează...' : 'Generează'}
            </button>
          </div>
        )}
        <div style={{marginLeft:'auto',display:'flex',gap:6}}>
          <button className="btn btn-sm" style={{background:'#217346',color:'white'}} onClick={()=>exportCSV(sorted,tab)}>📊 CSV</button>
          <button className="btn btn-sm" style={{background:'#555',color:'white'}} onClick={()=>printTable(tab==='foi-parcurs'?'Foi de parcurs':'CMR',sorted)}>🖨️ Listă</button>
          {!isDriver && selectedRow && (
            <button className="btn btn-warning btn-sm" onClick={()=>tab==='foi-parcurs'?openEditFoaie(selectedRow):openEditCmr(selectedRow)}>✏️ Modifică</button>
          )}
          {selectedRow && (
            <button className="btn btn-sm" style={{background:'#2d6ca2',color:'white'}}
              onClick={()=>tab==='foi-parcurs'?printFoaieParcurs(selectedRow):printCmr(selectedRow)}>🖨️ Print document</button>
          )}
          {!isDriver && selectedRow && (
            <button className="btn btn-danger btn-sm" onClick={()=>tab==='foi-parcurs'?delFoaie(selectedRow.nrCrt):delCmr(selectedRow.nrCrt)}>🗑️</button>
          )}
          <button className="btn btn-success btn-sm" onClick={tab==='foi-parcurs'?openAddFoaie:openAddCmr}>+ Adaugă</button>
        </div>
      </div>

      {tab==='foi-parcurs' && grupuriConsolidate && grupuriConsolidate.length > 0 && (
        <div style={{padding:'10px 14px',display:'flex',flexDirection:'column',gap:10}}>
          {grupuriConsolidate.map(grup => (
            <div key={grup.username} style={{border:'1px solid #d0dcea',borderRadius:6,padding:12,background:'#fafcff'}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8}}>
                <b>{grup.nrInmatriculare} — {grup.username} — {grup.data}</b>
                <button className="btn btn-sm" style={{background:'#2d6ca2',color:'white'}} onClick={()=>printFoaieConsolidata(grup)}>
                  🖨️ Printează
                </button>
              </div>
              <table style={{width:'100%',fontSize:12,borderCollapse:'collapse'}}>
                <thead><tr style={{textAlign:'left',borderBottom:'2px solid #ddd'}}>
                  <th style={{padding:4}}>Ora</th><th style={{padding:4}}>Traseu</th>
                  <th style={{padding:4}}>Km plecare</th><th style={{padding:4}}>Km sosire</th>
                  <th style={{padding:4}}>Km parcurși</th><th style={{padding:4}}>Scop</th>
                </tr></thead>
                <tbody>
                  {[...grup.curse].sort((a,b) => (Number(b.nrCrt)||0) - (Number(a.nrCrt)||0)).map(c => {
                    const km = (c.kmSosire!=null && c.kmPlecare!=null) ? (c.kmSosire-c.kmPlecare) : '';
                    return (
                      <tr key={c.nrCrt} style={{borderBottom:'1px solid #eee'}}>
                        <td style={{padding:4}}>{c.oraPlecare}–{c.oraSosire}</td>
                        <td style={{padding:4}}>{c.traseu}</td>
                        <td style={{padding:4}}>{c.kmPlecare}</td>
                        <td style={{padding:4}}>{c.kmSosire}</td>
                        <td style={{padding:4,fontWeight:'bold'}}>{km}</td>
                        <td style={{padding:4}}>{c.scopDeplasarii}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <div style={{display:'flex',gap:20,marginTop:8,fontSize:12.5}}>
                <span><b>Km total zi:</b> {grup.kmTotal ?? '—'}</span>
                <span><b>Consum normat mediu:</b> {grup.consumNormatMediu!=null ? grup.consumNormatMediu.toFixed(1) : '—'} l/100km</span>
                <span><b>Consum efectiv mediu:</b> {grup.consumEfectivMediu!=null ? grup.consumEfectivMediu.toFixed(1) : '—'} l/100km</span>
              </div>
            </div>
          ))}
        </div>
      )}

      {loading ? <Spinner/> : tab === 'foi-parcurs' ? (
        <div style={{overflowX:'auto'}}>
          <table>
            <thead>
              <tr>
                <SH col="nrInmatriculare">Nr. Auto</SH>
                <SH col="username">Șofer</SH>
                <SH col="dataFoii">Data</SH>
                <SH col="oraPlecare">Ore</SH><th>Km plecare</th><th>Km sosire</th><th>Km parcurși</th>
                <SH col="traseu">Traseu</SH><th>Scop</th>
              </tr>
              <tr style={{background:'#f0f4fa'}}>
                <th>
                  <select value={filters.nrInmatriculare||''} onChange={e=>setFilter('nrInmatriculare',e.target.value)}
                    style={{width:'100%',padding:'3px 6px',fontSize:11,border:'1px solid #ccc',borderRadius:3}}>
                    <option value="">Toate</option>
                    {nruri.map(n=><option key={n} value={n}>{n}</option>)}
                  </select>
                </th>
                <th>
                  <select value={filters.username||''} onChange={e=>setFilter('username',e.target.value)}
                    style={{width:'100%',padding:'3px 6px',fontSize:11,border:'1px solid #ccc',borderRadius:3}}>
                    <option value="">Toți</option>
                    {soferi.map(n=><option key={n} value={n}>{n}</option>)}
                  </select>
                </th>
                <th></th><th></th><th></th><th></th><th></th>
                <th><FilterInput value={filters.traseu||''} onChange={v=>setFilter('traseu',v)}/></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {sorted.map(r=>{
                const isSel = selectedRow?.nrCrt === r.nrCrt;
                const kmParcursi = (r.kmSosire!=null && r.kmPlecare!=null) ? (r.kmSosire - r.kmPlecare) : '';
                return (
                  <tr key={r.nrCrt} onClick={()=>setSelectedRow(isSel?null:r)}
                    style={{cursor:'pointer',background:isSel?'#e8f0fe':undefined}}>
                    <td><b>{r.nrInmatriculare}</b></td>
                    <td>{r.username}</td>
                    <td>{r.dataFoii}</td>
                    <td>{r.oraPlecare} — {r.oraSosire}</td>
                    <td style={{textAlign:'right'}}>{r.kmPlecare}</td>
                    <td style={{textAlign:'right'}}>{r.kmSosire}</td>
                    <td style={{textAlign:'right',fontWeight:'bold'}}>{kmParcursi}</td>
                    <td>{r.traseu}</td>
                    <td>{r.scopDeplasarii}</td>
                  </tr>
                );
              })}
              {sorted.length===0&&<tr><td colSpan={9} style={{textAlign:'center',padding:20,color:'#888'}}>Fără date</td></tr>}
            </tbody>
          </table>
        </div>
      ) : (
        <div style={{overflowX:'auto'}}>
          <table>
            <thead>
              <tr>
                <SH col="dataIntocmire">Data</SH>
                <SH col="expeditorNume">Expeditor</SH>
                <SH col="destinatarNume">Destinatar</SH>
                <th>Vehicul</th><th>Șofer</th>
                <SH col="totalDePlata">Total (RON)</SH>
              </tr>
              <tr style={{background:'#f0f4fa'}}>
                <th></th>
                <th><FilterInput value={filters.expeditorNume||''} onChange={v=>setFilter('expeditorNume',v)}/></th>
                <th><FilterInput value={filters.destinatarNume||''} onChange={v=>setFilter('destinatarNume',v)}/></th>
                <th>
                  <select value={filters.nrInmatriculare||''} onChange={e=>setFilter('nrInmatriculare',e.target.value)}
                    style={{width:'100%',padding:'3px 6px',fontSize:11,border:'1px solid #ccc',borderRadius:3}}>
                    <option value="">Toate</option>
                    {nruri.map(n=><option key={n} value={n}>{n}</option>)}
                  </select>
                </th>
                <th></th><th></th>
              </tr>
            </thead>
            <tbody>
              {sorted.map(r=>{
                const isSel = selectedRow?.nrCrt === r.nrCrt;
                return (
                  <tr key={r.nrCrt} onClick={()=>setSelectedRow(isSel?null:r)}
                    style={{cursor:'pointer',background:isSel?'#e8f0fe':undefined}}>
                    <td>{r.dataIntocmire}</td>
                    <td><b>{r.expeditorNume}</b></td>
                    <td>{r.destinatarNume}</td>
                    <td>{r.nrInmatriculare||'—'}</td>
                    <td>{r.username||'—'}</td>
                    <td style={{textAlign:'right',fontWeight:'bold'}}>{fmt(r.totalDePlata)}</td>
                  </tr>
                );
              })}
              {sorted.length===0&&<tr><td colSpan={6} style={{textAlign:'center',padding:20,color:'#888'}}>Fără date</td></tr>}
            </tbody>
          </table>
        </div>
      )}

      {/* ---------------- Modal Foaie de parcurs ---------------- */}
      {modal?.tip==='foaie' && (
        <Modal title={modal.mode==='add'?'Adaugă foaie de parcurs':'Editează foaie de parcurs'} onClose={()=>setModal(null)} onSave={saveFoaie}>
          {poateConduce && modal.mode==='add' && curseGps.length>0 && (
            <div className="form-row single" style={{background:'#eef6ff',border:'1px solid #bcd8f5',borderRadius:6,padding:'8px 10px',marginBottom:8}}>
              <div className="form-group">
                <label>📍 Preia din cursă GPS (opțional)</label>
                <select defaultValue="" onChange={e=>preiaDinCursaGps(e.target.value)}>
                  <option value="">-- Nicio cursă selectată --</option>
                  {curseGps.map(c=>(
                    <option key={c.id} value={c.id}>
                      {c.nrInmatriculare} — {c.dataStart} {c.oraStart} · {Number(c.distantaGpsKm||0).toFixed(1)} km
                    </option>
                  ))}
                </select>
                {formFoaie.cursaGpsId && (
                  <div style={{fontSize:12,color:'#1a3a5c',marginTop:4}}>
                    Distanță GPS estimată: {Number(formFoaie.distantaGps||0).toFixed(1)} km — poți corecta orice câmp mai jos.
                  </div>
                )}
              </div>
            </div>
          )}
          <div className="form-row">
            <div className="form-group"><label>Nr. Auto<span style={{color:'#e74c3c'}}> *</span></label>
              <select value={formFoaie.nrInmatriculare||''} onChange={e=>setFormFoaie({...formFoaie,nrInmatriculare:e.target.value})}>
                <option value="">-- Selectează vehiculul --</option>
                {nruri.map(n=><option key={n} value={n}>{n}</option>)}
              </select>
            </div>
            <div className="form-group"><label>Șofer<span style={{color:'#e74c3c'}}> *</span></label>
              <select value={formFoaie.username||''} onChange={e=>setFormFoaie({...formFoaie,username:e.target.value})}>
                <option value="">-- Selectează șoferul --</option>
                {soferi.map(n=><option key={n} value={n}>{n}</option>)}
              </select>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group"><label>Data<span style={{color:'#e74c3c'}}> *</span></label>
              <input type="date" value={formFoaie.dataFoii||''} onChange={e=>setFormFoaie({...formFoaie,dataFoii:e.target.value})}/>
            </div>
            <div className="form-group"><label>Traseu</label>
              <input type="text" value={formFoaie.traseu||''} onChange={e=>setFormFoaie({...formFoaie,traseu:e.target.value})}/>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group"><label>Ora plecare</label>
              <input type="time" value={formFoaie.oraPlecare||''} onChange={e=>setFormFoaie({...formFoaie,oraPlecare:e.target.value})}/>
            </div>
            <div className="form-group"><label>Ora sosire</label>
              <input type="time" value={formFoaie.oraSosire||''} onChange={e=>setFormFoaie({...formFoaie,oraSosire:e.target.value})}/>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group"><label>Km la plecare</label>
              <input type="number" value={formFoaie.kmPlecare??''} onChange={e=>setFormFoaie({...formFoaie,kmPlecare:e.target.value})}/>
            </div>
            <div className="form-group"><label>Km la sosire</label>
              <input type="number" value={formFoaie.kmSosire??''} onChange={e=>setFormFoaie({...formFoaie,kmSosire:e.target.value})}/>
              {formFoaie.distantaGps!=null && formFoaie.kmPlecare!=='' && (
                <button type="button" style={{fontSize:11,marginTop:4}}
                  onClick={()=>setFormFoaie(f=>({...f,kmSosire: Math.round(Number(f.kmPlecare||0) + Number(f.distantaGps||0))}))}>
                  ▶ din GPS ({Number(formFoaie.distantaGps).toFixed(1)} km)
                </button>
              )}
            </div>
          </div>
          <div className="form-row single">
            <div className="form-group"><label>Scopul deplasării</label>
              <input type="text" value={formFoaie.scopDeplasarii||''} onChange={e=>setFormFoaie({...formFoaie,scopDeplasarii:e.target.value})}/>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group"><label>Consum normat (l/100km)</label>
              <input type="text" value={formFoaie.consumNormat||''} onChange={e=>setFormFoaie({...formFoaie,consumNormat:e.target.value})}/>
            </div>
            <div className="form-group"><label>Consum efectiv (l/100km)</label>
              <input type="text" value={formFoaie.consumEfectiv||''} onChange={e=>setFormFoaie({...formFoaie,consumEfectiv:e.target.value})}/>
            </div>
          </div>
          <div className="form-row single">
            <div className="form-group"><label>Observații</label>
              <input type="text" value={formFoaie.observatii||''} onChange={e=>setFormFoaie({...formFoaie,observatii:e.target.value})}/>
            </div>
          </div>
          <div className="form-row single"><span style={{fontSize:11,color:'#888'}}>* Câmp obligatoriu</span></div>
        </Modal>
      )}

      {/* ---------------- Modal CMR ---------------- */}
      {modal?.tip==='cmr' && (
        <Modal title={modal.mode==='add'?'Adaugă document CMR':'Editează document CMR'} onClose={()=>setModal(null)} onSave={saveCmr}>
          <div className="form-row">
            <div className="form-group"><label>Vehicul (opțional)</label>
              <select value={formCmr.nrInmatriculare||''} onChange={e=>setFormCmr({...formCmr,nrInmatriculare:e.target.value})}>
                <option value="">-- Fără vehicul --</option>
                {nruri.map(n=><option key={n} value={n}>{n}</option>)}
              </select>
            </div>
            <div className="form-group"><label>Șofer (opțional)</label>
              <select value={formCmr.username||''} onChange={e=>setFormCmr({...formCmr,username:e.target.value})}>
                <option value="">-- Fără șofer --</option>
                {soferi.map(n=><option key={n} value={n}>{n}</option>)}
              </select>
            </div>
          </div>

          <hr style={{border:'none',borderTop:'1px solid #ddd',margin:'12px 0'}}/>
          <div style={{fontWeight:'bold',color:'#1a3a5c',fontSize:12.5,marginBottom:6}}>1-2. Expeditor / Destinatar</div>
          <div className="form-row">
            <div className="form-group"><label>Expeditor - nume<span style={{color:'#e74c3c'}}> *</span></label>
              <input type="text" value={formCmr.expeditorNume||''} onChange={e=>setFormCmr({...formCmr,expeditorNume:e.target.value})}/>
            </div>
            <div className="form-group"><label>Destinatar - nume<span style={{color:'#e74c3c'}}> *</span></label>
              <input type="text" value={formCmr.destinatarNume||''} onChange={e=>setFormCmr({...formCmr,destinatarNume:e.target.value})}/>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group"><label>Expeditor - adresă, țară</label>
              <input type="text" value={formCmr.expeditorAdresa||''} onChange={e=>setFormCmr({...formCmr,expeditorAdresa:e.target.value})}/>
            </div>
            <div className="form-group"><label>Țară expeditor</label>
              <input type="text" value={formCmr.expeditorTara||''} onChange={e=>setFormCmr({...formCmr,expeditorTara:e.target.value})}/>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group"><label>Destinatar - adresă</label>
              <input type="text" value={formCmr.destinatarAdresa||''} onChange={e=>setFormCmr({...formCmr,destinatarAdresa:e.target.value})}/>
            </div>
            <div className="form-group"><label>Țară destinatar</label>
              <input type="text" value={formCmr.destinatarTara||''} onChange={e=>setFormCmr({...formCmr,destinatarTara:e.target.value})}/>
            </div>
          </div>

          <hr style={{border:'none',borderTop:'1px solid #ddd',margin:'12px 0'}}/>
          <div style={{fontWeight:'bold',color:'#1a3a5c',fontSize:12.5,marginBottom:6}}>3-5. Locuri și documente</div>
          <div className="form-row">
            <div className="form-group"><label>Locul eliberării mărfii (3)</label>
              <input type="text" value={formCmr.locLivrare||''} onChange={e=>setFormCmr({...formCmr,locLivrare:e.target.value})}/>
            </div>
            <div className="form-group"><label>Țara (3)</label>
              <input type="text" value={formCmr.tara3||''} onChange={e=>setFormCmr({...formCmr,tara3:e.target.value})}/>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group"><label>Locul încărcării (4)</label>
              <input type="text" value={formCmr.locIncarcare||''} onChange={e=>setFormCmr({...formCmr,locIncarcare:e.target.value})}/>
            </div>
            <div className="form-group"><label>Data încărcării (4)</label>
              <input type="date" value={formCmr.dataIncarcare||''} onChange={e=>setFormCmr({...formCmr,dataIncarcare:e.target.value})}/>
            </div>
          </div>
          <div className="form-row single">
            <div className="form-group"><label>Documente anexate (5)</label>
              <input type="text" value={formCmr.documenteAnexate||''} onChange={e=>setFormCmr({...formCmr,documenteAnexate:e.target.value})}/>
            </div>
          </div>

          <hr style={{border:'none',borderTop:'1px solid #ddd',margin:'12px 0'}}/>
          <div style={{fontWeight:'bold',color:'#1a3a5c',fontSize:12.5,marginBottom:6}}>6-12. Descrierea mărfii</div>
          <div className="form-row">
            <div className="form-group"><label>Mărci și numere (6)</label>
              <input type="text" value={formCmr.marcaje||''} onChange={e=>setFormCmr({...formCmr,marcaje:e.target.value})}/>
            </div>
            <div className="form-group"><label>Nr. colete (7)</label>
              <input type="text" value={formCmr.nrColete||''} onChange={e=>setFormCmr({...formCmr,nrColete:e.target.value})}/>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group"><label>Mod de ambalare (8)</label>
              <input type="text" value={formCmr.modAmbalare||''} onChange={e=>setFormCmr({...formCmr,modAmbalare:e.target.value})}/>
            </div>
            <div className="form-group"><label>Natura mărfii (9)</label>
              <input type="text" value={formCmr.naturaMarfii||''} onChange={e=>setFormCmr({...formCmr,naturaMarfii:e.target.value})}/>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group"><label>Nr. statistic (10)</label>
              <input type="text" value={formCmr.nrStatistic||''} onChange={e=>setFormCmr({...formCmr,nrStatistic:e.target.value})}/>
            </div>
            <div className="form-group"><label>Greutate brută, kg (11)</label>
              <input type="text" value={formCmr.greutateBruta||''} onChange={e=>setFormCmr({...formCmr,greutateBruta:e.target.value})}/>
            </div>
          </div>
          <div className="form-row single">
            <div className="form-group"><label>Volum, m³ (12)</label>
              <input type="text" value={formCmr.volum||''} onChange={e=>setFormCmr({...formCmr,volum:e.target.value})}/>
            </div>
          </div>

          <hr style={{border:'none',borderTop:'1px solid #ddd',margin:'12px 0'}}/>
          <div style={{fontWeight:'bold',color:'#1a3a5c',fontSize:12.5,marginBottom:6}}>13-19. Instrucțiuni și transportator</div>
          <div className="form-row single">
            <div className="form-group"><label>Instrucțiuni ale expeditorului (13)</label>
              <input type="text" value={formCmr.instructiuniExpeditor||''} onChange={e=>setFormCmr({...formCmr,instructiuniExpeditor:e.target.value})}/>
            </div>
          </div>
          <div className="form-row single">
            <div className="form-group"><label>Ramburs (15)</label>
              <input type="text" value={formCmr.ramburs||''} onChange={e=>setFormCmr({...formCmr,ramburs:e.target.value})}/>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group"><label>Transportator - nume (16)</label>
              <input type="text" value={formCmr.transportatorNume||''} onChange={e=>setFormCmr({...formCmr,transportatorNume:e.target.value})}/>
            </div>
            <div className="form-group"><label>Transportator - adresă, țară (16)</label>
              <input type="text" value={formCmr.transportatorAdresa||''} onChange={e=>setFormCmr({...formCmr,transportatorAdresa:e.target.value})}/>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group"><label>Țară transportator</label>
              <input type="text" value={formCmr.transportatorTara||''} onChange={e=>setFormCmr({...formCmr,transportatorTara:e.target.value})}/>
            </div>
            <div className="form-group"><label>Transportatori succesivi (17)</label>
              <input type="text" value={formCmr.transportatoriSuccesivi||''} onChange={e=>setFormCmr({...formCmr,transportatoriSuccesivi:e.target.value})}/>
            </div>
          </div>
          <div className="form-row single">
            <div className="form-group"><label>Rezervele transportatorului (18)</label>
              <input type="text" value={formCmr.rezerveTransportator||''} onChange={e=>setFormCmr({...formCmr,rezerveTransportator:e.target.value})}/>
            </div>
          </div>
          <div className="form-row single">
            <div className="form-group"><label>Convenții speciale (19)</label>
              <input type="text" value={formCmr.conventiiSpeciale||''} onChange={e=>setFormCmr({...formCmr,conventiiSpeciale:e.target.value})}/>
            </div>
          </div>

          <hr style={{border:'none',borderTop:'1px solid #ddd',margin:'12px 0'}}/>
          <div style={{fontWeight:'bold',color:'#1a3a5c',fontSize:12.5,marginBottom:6}}>20. De plată</div>
          <div className="form-row">
            <div className="form-group"><label>Preț transport</label>
              <input type="number" value={formCmr.pretTransport||''} onChange={e=>setFormCmr({...formCmr,pretTransport:e.target.value})}/>
            </div>
            <div className="form-group"><label>Reduceri</label>
              <input type="number" value={formCmr.reduceri||''} onChange={e=>setFormCmr({...formCmr,reduceri:e.target.value})}/>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group"><label>Sold</label>
              <input type="number" value={formCmr.sold||''} onChange={e=>setFormCmr({...formCmr,sold:e.target.value})}/>
            </div>
            <div className="form-group"><label>Taxe suplimentare</label>
              <input type="number" value={formCmr.taxeSuplimentare||''} onChange={e=>setFormCmr({...formCmr,taxeSuplimentare:e.target.value})}/>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group"><label>Alte cheltuieli</label>
              <input type="number" value={formCmr.alteCheltuieli||''} onChange={e=>setFormCmr({...formCmr,alteCheltuieli:e.target.value})}/>
            </div>
            <div className="form-group"><label>Total de plată</label>
              <input type="number" value={formCmr.totalDePlata||''} onChange={e=>setFormCmr({...formCmr,totalDePlata:e.target.value})}/>
            </div>
          </div>

          <hr style={{border:'none',borderTop:'1px solid #ddd',margin:'12px 0'}}/>
          <div style={{fontWeight:'bold',color:'#1a3a5c',fontSize:12.5,marginBottom:6}}>21-24. Întocmire și semnături</div>
          <div className="form-row">
            <div className="form-group"><label>Întocmit la (loc)</label>
              <input type="text" value={formCmr.locIntocmire||''} onChange={e=>setFormCmr({...formCmr,locIntocmire:e.target.value})}/>
            </div>
            <div className="form-group"><label>Data întocmirii</label>
              <input type="date" value={formCmr.dataIntocmire||''} onChange={e=>setFormCmr({...formCmr,dataIntocmire:e.target.value})}/>
            </div>
          </div>
          <div className="form-row" style={{alignItems:'center'}}>
            <label style={{display:'flex',alignItems:'center',gap:6,fontSize:12.5}}>
              <input type="checkbox" checked={!!formCmr.semnatExpeditor} onChange={e=>setFormCmr({...formCmr,semnatExpeditor:e.target.checked})}/>
              Semnat de expeditor (22)
            </label>
            <label style={{display:'flex',alignItems:'center',gap:6,fontSize:12.5}}>
              <input type="checkbox" checked={!!formCmr.semnatTransportator} onChange={e=>setFormCmr({...formCmr,semnatTransportator:e.target.checked})}/>
              Semnat de transportator (23)
            </label>
          </div>
          <div className="form-row single">
            <label style={{display:'flex',alignItems:'center',gap:6,fontSize:12.5}}>
              <input type="checkbox" checked={!!formCmr.semnatDestinatar} onChange={e=>setFormCmr({...formCmr,semnatDestinatar:e.target.checked})}/>
              Semnat de destinatar — marfă primită (24)
            </label>
          </div>
          <div className="form-row single"><span style={{fontSize:11,color:'#888'}}>* Câmp obligatoriu</span></div>
        </Modal>
      )}
    </div>
  );
}
